import {getSignUrl} from './tools';
import {host} from '@utils/hostConf';
let wx = window.wx || {};

/**
 * @desc 判断是否是微信内置浏览器
 * @return  Boolean
 **/
export function isWeiXin() {
  if (typeof window == 'undefined') return false;
  const ua = window.navigator.userAgent.toLowerCase();
  return ua.match(/MicroMessenger/i) == 'micromessenger';
}

/**
 * @desc wechat config 初始化
 * @param options {{wxDebug:(boolean) 是否打开微信调试, wxApiList:[] 需要使用的api列表}}
 */
export function wxConfig(options) {
  wx.config({
    debug: options.wxDebug || false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: options.appId, // 必填，公众号的唯一标识
    timestamp: options.timestamp, // 必填，生成签名的时间戳
    nonceStr: options.nonceStr, // 必填，生成签名的随机串
    signature: options.signature, // 必填，签名，见附录1
    jsApiList: options.wxApiList, // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    openTagList: options.wxOpenTagList || ['wx-open-launch-weapp'],
  });
}

export function wxInit() {
  let form = new FormData();
  form.append('url', getSignUrl());
  form.append('domain', window.location.hostname);
  return fetch(`${host.wxapi}api/wechat/js-ticket`, {
    method: 'POST',
    credentials: 'same-origin',
    body: form,
  })
    .then(response => response.json())
    .then(resp => {
      if (resp.status != '0') {
        // new Image().src = `/jsapi/log?tag=wx_init_error&str=${JSON.stringify(resp)}`;
        return false;
      }
      wxConfig(
        Object.assign(resp.data, {
          wxApiList: [
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'chooseImage',
            'getBrandWCPayRequest',
            'getLocation',
            'openLocation',
          ],
          wxOpenTagList: ['wx-open-launch-weapp'],
        })
      );
      return true;
    });
}

/**
 * 微信初始化带回调
 */
export function wxReady() {
  if (isWeiXin()) {
    return wxInit().then(isInit => {
      if (isInit) {
        return new Promise((resolve, reject) => {
          wx.ready(() => {
            resolve();
          });
        });
      } else {
        return Promise.reject('wx need init');
      }
    });
  } else {
    return Promise.reject('wx getLocation dose not available when wx env');
  }
}
